import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchAmritVarshaAction } from '../../../utils/redux/amritVarsha/amritVarshaAction';
// import './AmritVarshaPage.css'
import { Button, Card, Col, Container, Form, InputGroup, Row, Table } from 'react-bootstrap';
import '../CSS/common.css';

const AmritVarshaPage = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { amritVarsha } = useSelector((state) => state.amritVarsha);
    const [params] = useSearchParams();

    const [searchQuery, setSearchQuery] = useState(params.get('searchQuery') || '');
    const [nugget, setNugget] = useState(params.get('nugget') || '');

    useEffect(() => {
        const param = {
            search: searchQuery,
            nugget: nugget
        };
        dispatch(fetchAmritVarshaAction(param));
        // eslint-disable-next-line
    }, []);

    const handleResetFilters = () => {
        setNugget('');
        setSearchQuery('');
        navigate(`/amrit-varsha`);
        dispatch(fetchAmritVarshaAction());
    };

    // Handle search on enter press
    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            navigate(`/amrit-varsha?searchQuery=${searchQuery}&nugget=${nugget}`);
            const param = {
                search: searchQuery,
                nugget: nugget,
            };
            dispatch(fetchAmritVarshaAction(param));
        }
    };

    const handleSearchButtonClick = () => {
        navigate(`/amrit-varsha?searchQuery=${searchQuery}&nugget=${nugget}`);
        const param = {
            search: searchQuery,
            nugget: nugget,
        };
        dispatch(fetchAmritVarshaAction(param));
    }

    // Handle category change
    const handleNuggetChange = (e) => {
        setNugget(e.target.value);
        navigate(`/amrit-varsha?searchQuery=${searchQuery}&nugget=${e.target.value}`);
        dispatch(fetchAmritVarshaAction({
            search: searchQuery,
            nugget: e.target.value
        }));
    };

    if (!amritVarsha) {
        return <div className="text-center mt-5">Loading...</div>;
    }
    return (
        <Container className="py-4">
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-4">
                <h2 className="mb-0">Available Techniques</h2>
            </div>

            <Card className="mb-4 shadow-sm border-0">
                <Card.Body>
                    <Row className="gy-3 gx-3 align-items-end">
                        <Col md={4} xs={12}>
                            <Form.Label htmlFor="searchInput" className="fw-semibold">Search</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    id="searchInput"
                                    placeholder="Search techniques..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyPress={handleSearch}
                                />
                            </InputGroup>
                            <Button
                                className='mt-2'
                                onClick={handleSearchButtonClick}
                            >
                                Search
                            </Button>
                        </Col>
                        <Col md={3} xs={6}>
                            <Form.Label className="fw-semibold">Golden Nugget Exist</Form.Label>
                            <Form.Select
                                value={nugget}
                                onChange={handleNuggetChange}
                            >
                                <option value="">All Amrit Varsha</option>
                                <option value={true}>Golden Nugget AV</option>
                                <option value={false}>Other AV</option>
                            </Form.Select>
                        </Col>
                        <Col md={1} xs={12} className="d-flex gap-2 justify-content-end align-items-center mt-md-0 mt-3">
                            <Button variant="secondary" onClick={handleResetFilters}>
                                Reset
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Table View */}
            <div className="d-none d-md-block">
                <Table hover responsive className="talk-table">
                    <colgroup>
                        <col style={{ width: '50%' }} />
                        <col style={{ width: '40%' }} />
                        <col style={{ width: '10%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Link</th>
                            <th>Nugget Exist</th>
                        </tr>
                    </thead>
                    <tbody>
                        {amritVarsha?.map((tech) => (
                            <tr
                                key={tech._id}
                                className="talk-row"
                            >
                                <td>
                                    <div
                                        className="title-cell"
                                        onClick={() => navigate(`/amrit-varsha/${tech._id}`)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong title={tech.title}>{tech.title}</strong>
                                    </div>
                                </td>
                                <td><a href={tech?.link} target='_blank'>Google Drive Link</a></td>
                                <td>
                                    {tech?.nugget ? "Yes" : "No"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Mobile Card View */}
            <div className="d-md-none">
                <div className="talk-cards">
                    {amritVarsha?.map((tech) => (
                        <div
                            key={tech._id}
                            className="talk-card-mobile"
                            onClick={() => navigate(`/amrit-varsha/${tech._id}`)}
                        >
                            <h5 className="talk-card-title" title={tech.title}>
                                {tech.title}
                            </h5>
                            <div className="talk-card-meta">
                                <span className="meta-item">
                                    <small className="text-muted">Link:</small> {tech?.link}
                                </span>
                                <span className="meta-item">
                                    <small className="text-muted">Nugget Exist:</small> {tech?.nugget ? "Yes" : "No"}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    )
}

export default AmritVarshaPage